angular.module('impactx.search').controller('SearchListCtrl', SearchListController);

SearchListController.$inject = ['$scope', 'searchFilter', 'AddToBasketService', 'SearchService', 'ToastService', 'dataGen', '$context', 'sidebarShow', 'SearchProcessService', 'AppConfiguration'];

function SearchListController($scope, searchFilter, AddToBasketService, SearchService, ToastService, dataGen, $context, sidebarShow, SearchProcessService, AppConfiguration) {

    searchFilter.currentPage = searchFilter.pageSearchAll;
    $scope.tendersTemplate = "modules/search/templates/tenders.tmpl.html";
    $scope.lotsTemplate = "modules/search/templates/lots.tmpl.html";
    $scope.catalogsTemplate = "modules/search/templates/catalogs.tmpl.html";
    $scope.productsTemplate = "modules/search/templates/products.tmpl.html";
    $scope.themeWorldsTemplate = "modules/search/templates/themeworlds.tmpl.html";
    $scope.hasActiveThemeWorld = $context.hasActiveThemeWorldSearch.value;
    $scope.hasSearchInput = !!searchFilter.searchInput;
    $scope.recentSearchText = searchFilter.searchInput;

    this.sidebarShow = sidebarShow;


    $scope.search = function () {
        $scope.data = undefined;
        $scope.recentSearchText = searchFilter.searchInput;
        SearchProcessService.activateSearchProcess();
        SearchService.search("/search/all").then(function () {
            if (SearchService.model.data.searchResults.searchError)
            {
                ToastService.openStandardToast(SearchService.model.data.searchResults.searchError);
            }
            $scope.data = SearchService.model.data;
            $scope.trns = SearchService.model.trns;
            $scope.fixedFilters = searchFilter.getSearchFilterData();
            $scope.no_result = SearchService.model.no_result;
            var attributeSearch = $scope.data.searchResults.attributeSearch;
            if (attributeSearch) {
                $scope.facetResults = attributeSearch.facetResults;
                if (AppConfiguration.get('hasGuidingClassification') && attributeSearch.eclassFilter) {
                    $scope.eclassFilter = attributeSearch.eclassFilter;
                    $scope.eclassFilter.selectedItem = searchFilter.selectedEClass;
                }
            }
            else {
                $scope.facetResults = [];
            }
        })
    };

    $scope.searchProductFamily = function (selected) {
        searchFilter.getSearchFilterData().procurementGroup.selected = null;
        searchFilter.getSearchFilterData().productFamily.selected = selected;
        $scope.search();
    };

    $scope.searchProcurementGroup = function (selected) {
        searchFilter.getSearchFilterData().procurementGroup.selected = selected;
        $scope.search();
    };

    $scope.search();

    $scope.addToBasket = AddToBasketService.addToBasket;

    $scope.hasTenders = SearchService.hasTenders;

    $scope.hasLots = SearchService.hasLots;

    $scope.hasProducts = SearchService.hasProducts;

    $scope.hasThemeWorlds = SearchService.hasThemeWorlds;

    $scope.hasCats = SearchService.hasCats;

    $scope.nextLevel = function (selectedNode) {
        return dataGen.getData({}, {prgId: selectedNode.id, filterIdentifier: 'search'}, "/search/filter/eclass", null, true).then(function (data) {
            if (impactX.isDefined(data, "data.items")) {
                return data.data.items;
            }
        });
    };

    $scope.selectedItemChange = function (selectedNode) {
        searchFilter.getSearchFilterData().productGroupId = impactX.isDefined(selectedNode, "id");
        searchFilter.selectedEClass = selectedNode;
        $scope.search();
    };

    $scope.searchTextClearFilter = function (classificationName) {
        searchFilter.getSearchFilterData().productGroupId = undefined;
        $scope.eclassFilter = undefined;
        searchFilter.selectedEClass = undefined;
        searchFilter.searchInput = classificationName;
        $scope.hasSearchInput = true;
        $scope.search();
    };
}